import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { useGetVehicleManufacturers } from "../../../queries/useGetVehicleManufacturers";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { Section } from "../../../ui/Section/Section";
import { SectionHeading } from "../Common/SectionHeading";

type ReccommendedForProps = {
  part: TirePartItem | null;
};

export const ReccommendedFor: FunctionComponent<ReccommendedForProps> = ({
  part,
}) => {
  const [language] = useLanguage();
  const { data: manufacturers = [] } = useGetVehicleManufacturers();
  const manufacturersIds = new Set(
    manufacturers.map(({ value }) => String(value))
  );
  const list =
    part?.partDetails.primaryPart.tireRecommendedVehiclesList
      .map(
        ({
          recommendedVehicleDescription,
          recommendedVehicleId,
          recommendedVehicleManufacturerId,
          recommendedVehicleModelId,
        }) => ({
          key: `${recommendedVehicleId}-${recommendedVehicleModelId}`,
          recommendedVehicleManufacturerId,
          value: recommendedVehicleDescription[language],
        })
      )
      .filter(({ recommendedVehicleManufacturerId, value }) => {
        const checks = [
          value,
          manufacturersIds.has(recommendedVehicleManufacturerId),
        ];
        return checks.every(Boolean);
      }) || [];

  if (!list.length) {
    return null;
  }

  return (
    <Section>
      <SectionHeading translation="searchResults.reccommendedFor" />
      <ul className="text-xs max-h-24 overflow-x-auto list-disc list-inside grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {list.map(({ key, value }) => (
          <li key={key}>{value}</li>
        ))}
      </ul>
    </Section>
  );
};
